// theme-context.js
import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();
const THEME_KEY = "theme";

export function ThemeProvider({ children }) {
	const [theme, setTheme] = useState(() => {
		// Normalize legacy theme values — only "light" and "dark" are supported now
		const saved = localStorage.getItem(THEME_KEY);
		return saved === "dark" ? "dark" : "light";
	});

	useEffect(() => {
		// apply to <html> for CSS vars
		document.documentElement.setAttribute("data-theme", theme);
		// save for next visit
		localStorage.setItem(THEME_KEY, theme);
	}, [theme]);

	const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));

	return <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);